:host {
  --_shell-page-content-background: var(--color-background-primary);
  --_shell-page-header-background: var(--color-background-primary);
  --_shell-page-responsive-content-block-start-inset: var(--dimension-space-400);
  --_shell-page-content-block-start-inset: var(
    --ds-shell-page-content-block-start-inset,
    var(--_shell-page-responsive-content-block-start-inset)
  );
  --ds-shell-page-sticky-header-block-size: var(--dimension-size-600);
  --ds-shell-page-content-block-start-offset: calc(
    var(--ds-shell-page-sticky-header-block-size) +
      var(--_shell-page-content-block-start-inset)
  );
  display: block;
  position: relative;
  min-width: 0;
  min-height: 100%;
  box-sizing: border-box;
  background: var(--_shell-page-content-background);
}

:host(.shell-page-host--surface-secondary) {
  --_shell-page-content-background: var(--color-background-secondary);
}

:host(.shell-page-host--surface-secondary[responsive-mode='desktop']),
:host(.shell-page-host--surface-secondary[responsive-mode='tablet']) {
  --_shell-page-header-background: var(--color-background-secondary);
}

:host([responsive-mode='tablet']),
:host([responsive-mode='mobile']) {
  --_shell-page-responsive-content-block-start-inset: var(--dimension-space-200);
}

:host([responsive-mode='mobile']) {
  --ds-shell-page-sticky-header-block-size: calc(
    var(--dimension-size-500) + var(--dimension-space-200)
  );
}

:host(.shell-page-host--header-compact),
:host(.shell-page-host--header-constrained) {
  --_shell-page-content-block-start-inset: var(
    --ds-shell-page-compact-content-block-start-inset,
    var(--_shell-page-responsive-content-block-start-inset)
  );
}

:host(.shell-page-host--inset-none),
:host(.shell-page-host--block-start-inset-none) {
  --_shell-page-content-block-start-inset: 0px;
}

.shell-page__scroll-sentinel {
  position: absolute;
  inset-block-start: var(--ds-shell-page-header-travel, 0);
  inset-inline-start: 0;
  width: var(--dimension-stroke-width-012);
  height: var(--dimension-stroke-width-012);
  pointer-events: none;
}

.shell-page__sticky-header {
  position: sticky;
  inset-block-start: var(--ds-shell-page-sticky-offset, 0);
  z-index: var(--dimension-z-index-raised);
  min-width: 0;
  background: var(--_shell-page-header-background);
  overflow: visible;
  overflow-anchor: none;
}

.shell-page__desktop-header ::slotted(ds-bar-title),
.shell-page__desktop-header ::slotted(ds-bar-workflow),
.shell-page__mobile-header ::slotted(ds-mobile-header) {
  display: block;
  min-width: 0;
}

.shell-page__desktop-header[hidden],
.shell-page__mobile-header[hidden] {
  display: none;
}

:host(.shell-page-host--mobile) .shell-page__scroll-sentinel,
:host(.shell-page-host--mobile) .shell-page__flow-spacer {
  display: none;
}

.shell-page__flow-spacer {
  height: var(--ds-shell-page-flow-spacer, 0);
  background: var(--_shell-page-content-background);
}

.shell-page__content {
  min-width: 0;
  box-sizing: border-box;
  background: var(--_shell-page-content-background);
}

:host(.shell-page-host--inset-default) .shell-page__content {
  padding: var(--dimension-space-400);
  padding-block-start: var(--_shell-page-content-block-start-inset);
}

:host(.shell-page-host--inset-default[responsive-mode='tablet']) .shell-page__content,
:host(.shell-page-host--inset-default[responsive-mode='mobile']) .shell-page__content {
  padding: var(--dimension-space-200);
  padding-block-start: var(--_shell-page-content-block-start-inset);
}

:host(.shell-page-host--inset-none) .shell-page__content {
  padding: 0;
}
